import { useOverrideWorkModeContext } from './useOverrideWorkModeContext';
import { useWorkModeInternal } from './useWorkModeInternal';

export const useWorkMode = () => {
  const override = useOverrideWorkModeContext();
  const internal = useWorkModeInternal();

  return { ...internal, ...(override ?? {}) };
};
